<template>
    <section id="monitor-table-set" class="d-flex justify-space-between">
        <div class="monitor-table-set__container">
            <MonitorOption  v-for="(value, index) in option_set" 
                :key="index"
                :label="value.label"
                :current_option="value.current_option_value"
                :options="value.option_array"
                :description="value.description"
                @change_filter_option_value="change_filter_option_value"
            />
        </div>
        <slot name="remarks"></slot>
    </section>
</template>

<script>
    import MonitorOption from "./monitor_option.vue"
	export default {
        // 自訂觀測表格選項元件，這個元件的功能為把數個 option 的值統合傳回給父元件
		name: 'monitor_option_set',

        components: { MonitorOption },

        props: {
            // 把 option 裡面需要的放的資訊都在放在 array 中
            // 包含 label: label 的用處是此元件 emit 目前所有選項value 的 key
            // 包含 current_option: 剛載入頁面時為 option 的預設選項
            // 包含 options: 可供選擇的選項
            // 值得注意的是，過濾方法寫在使用這個元件的父元件，
            // 流程為 改變選項 => monitor_option 傳單一 option value => monitor_option_set 傳全部 option value 回父元件
            // 父元件根據 value 改變 current_option_value , datatable， 由於目前的選項來源是根據表格值的 unique，所以之後再重新修正 option_set
            option_set: {
                type: Array,
                default () {
                    return []
                }
            },
        },

        data() {
			return {
                filtered_cond: {}
            }
        },

        methods: {
            //  init_filtered_cond 是第一輪過濾資料時，初始化 filtered_cond: 把全部選項的 key value 存進 object 中
            //  transmit_data 是改變被選的選項的 value 以及把值傳回 父元件 
            init_filtered_cond() {
                let filtered_cond = {};
                this.option_set.forEach(item => {
                    filtered_cond[item.label] = item.current_option_value
                    return filtered_cond
                })
                this.filtered_cond = filtered_cond
            },
            change_filter_option_value(label, current_option_value) {
                if (JSON.stringify(this.filtered_cond) == "{}") {
                    this.init_filtered_cond()
                }else{
                    this.filtered_cond[label] = current_option_value
                }
                this.$emit('filter_data', this.filtered_cond, label)
            },
            // 用 watch 會一直遞迴
            change_option_set() {
                this.init_filtered_cond()
                this.$emit('filter_data', this.filtered_cond)
            }
        },
	}
</script>

<style lang="scss" scoped>
    @import '../../../css/mixin.scss';

    #monitor-table-set {
        @include tablet {
            flex-wrap: wrap;
        }

        .monitor-table-set__container {
            display: flex;

            @include mobile {
                flex-direction: column;
            }
        }
    }
</style>